export default __webpack_public_path__ + "images/f810788d6f5c5cf9cf8f0ec8f478cf21-affirm.svg";